import { Button, DatePicker, Form, Input, notification, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactQuill from 'react-quill';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import moment from 'moment';
import TextArea from 'antd/lib/input/TextArea';
import API_SERVICE from 'shared/services/api-service';
import { useHistory } from 'react-router-dom';


const { Option } = Select;
dayjs.extend(customParseFormat);
interface Props {
    selectedDate: any,
    closeModal:any,
    getCurrSchedule:any
}
export default function UpcommingCoursesForm(props: Props){
    const {selectedDate, closeModal, getCurrSchedule} = props;
    const { t } = useTranslation();
    const history: any = useHistory();
    const [saving, setSaving] = useState(false);
    const [items, setItems] = useState(null as any);
    const [users, setUsers] = useState(null as any);
    const [schedules, setSchedules] = useState(null as any);
    
    const modules = {
        toolbar: {
            container: [  
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],  
                ['bold', 'italic', 'underline'],  
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],  
                [{ 'align': [] }],  
                ['link', 'image'],  
                ['clean'],  
                [{ 'color': [] }]  
            ],  
            handlers: {
            //   image: imageHandler
            }
        }
    };
    
    const formats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "indent",
        "link",
        "image",
        "imageBlot" // #5 Optinal if using custom formats
    ];
    const refreshItems = async () => {
      
        try {
            const params: any = { order_by: 'id', page: 1,per_page: 'all', order: 'DESC' }
            const {
                data: {
                    data: {
                        count,
                        current_page,
                        items,
                        per_page,
                        total,
                    },
                },
            } = await API_SERVICE.fetchCoursesAdmin(params);
            setItems(items);
            console.log('itemsss', items)
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            
        }
    };
    const refreshusers = async () => {
        try {
            const params: any = {per_page: 1000, type: 'student'};
            
            const {
                data: {
                    data: {
                        count,
                        current_page,
                        items,
                        per_page,
                        total,
                    },
                },
            } = await API_SERVICE.fetchUsers(params);
            setUsers(items);
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {

        }
    };
    
    useEffect(() => {
        refreshItems();
        refreshusers();
    }, []);
    return <div className='container-fluid'>
        <div className='row'>
            <div className='col-md-12 col-sm-12'>
                <div className='bg-white pl-4 pr-4'>
                    <Form
                        size="large"
                        layout="vertical"
                        requiredMark={true}
                        onFinish={(value) => {
                            const reqObj: any = value;
                            console.log(reqObj);
                            reqObj['schedule_date'] = selectedDate;
                            setSaving(true);
                            API_SERVICE.createCourseSchedule(reqObj).then((d) => {
                                getCurrSchedule();
                                closeModal();
                            }).catch((e) => {
                                notification.error({ message: API_SERVICE.handleErrors(e) });
                                setSaving(false);
                                closeModal();
                            });
                        }}
                    >
                        <Form.Item
                            label={t('title.label')}
                            name={'subject'}
                            rules={[
                                { required: true, message: t('title.required') },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label={t('Course')}
                            name={'course_id'}
                            rules={[
                                { required: true, message: t('Course Required') },
                            ]}
                        >
                            <Select placeholder={'Select Course'}>
                            { items && items.map((item:any) => {
                                return <>
                                    {item?.course && item?.course.map((courseItem:any)=>{
                                        return <Option value={courseItem?.id}>{courseItem?.title}</Option>;
                                    })}
                                </>
                            })}
                                
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label={t('Users')}
                            name={'students'}
                            rules={[
                                { required: true, message: t('Course Required') },
                            ]}
                        >
                            <Select 
                            mode="multiple"
                            allowClear
                            filterOption={true}
                            optionFilterProp={'children'}
                            placeholder="Select Users">
                            { users && users.map((user:any) => {
                                return <Option value={user?.id}>{user?.name}</Option>;
                            })}
                                
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label={t('Schedule Date')}
                            name={'schedule_date'}
                            rules={[
                                // { required: true, message: t('Date Required') },
                            ]}
                        >
                            
                            <DatePicker disabled={true}
                                defaultValue={moment(selectedDate)} 
                                // format={'YYYY-MM-DD'} 
                            />
                        </Form.Item>
                        <Form.Item
                            label={t('Message')}
                            name={'message'}
                            rules={[
                                { required: true, message: t('Message Required') },
                            ]}
                        >
                            {/* <ReactQuill
                                modules={modules} formats={formats} 
                            /> */}
                            <TextArea />
                        </Form.Item>
                        <Form.Item>
                            <Button
                                htmlType="submit"
                                loading={saving}
                                shape="round"
                                size={'large'}
                                className="submit btn-blue"
                            >
                                {t('genDict.save')}
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    </div>
}